import React from "react";
import { ModalWrapper } from "../ModalWrapper/ModalWrapper";
import { kebabToCamelCase } from "../../helpers";

const DIALOG_CONFIGS = {
  "duplicate confirmed": {
    title: "Confirm Manuscript",
    message: "Do you want to request confirmation from the other publisher?",
    options: [
      {
        id: "request-confirmation",
        label: "Request confirmation",
        type: "checkbox"
      }
    ]
  },
  "suspect paper mill": {
    title: "Paper Mill Suspect",
    message: "Do you want to also add this to the SignalCheck?",
    options: [
      {
        id: "add-to-watchlist",
                  label: "Add to SignalCheck",
        type: "checkbox"
      },
      {
        id: "comment",
        label: "Comment:",
        type: "textarea",
        rows: 3
      }
    ]
  }
};

function convertDialogOptionKeys(options) {
  return Object.entries(options).reduce((result, [key, value]) => {
    if (value) {
      result[kebabToCamelCase(key)] = value;
    }
    return result;
  }, {});
}

const ConfirmationDialog = ({ actionType, isOpen, onClose, onApply }) => {
  const [optionsState, setOptionsState] = React.useState({});
  const config = DIALOG_CONFIGS[actionType] || {};

  React.useEffect(() => {
    if (isOpen && config.options) {
      const initialState = {};
      config.options.forEach(option => {
        initialState[option.id] = option.type === "checkbox" ? false : "";
      });
      setOptionsState(initialState);
    }
  }, [isOpen, actionType]);

  const handleOptionChange = (optionId, value) => {
    setOptionsState(prev => ({
      ...prev,
      [optionId]: value
    }));
  };

  const handleApply = () => {
    onApply(convertDialogOptionKeys(optionsState));
  };

  if (!isOpen || !config) return null;

  return (
    <ModalWrapper
      isOpen={isOpen}
      onClose={onClose}
      title={config.title}
      modalClassSize="modal-md"
    >
      <div className="mb-3">{config.message}</div>

      {config.options?.map(option => (
        <div className="mb-3" key={option.id}>
          {option.type === "checkbox" ? (
            <label>
              <input
                type="checkbox"
                checked={!!optionsState[option.id]}
                onChange={e => handleOptionChange(option.id, e.target.checked)}
              />
              <span className="ms-2">{option.label}</span>
            </label>
          ) : option.type === "textarea" ? (
            <>
              <label>{option.label}</label>
              <textarea
                className="form-control"
                value={optionsState[option.id] || ""}
                onChange={e => handleOptionChange(option.id, e.target.value)}
                rows={option.rows || 3}
              />
            </>
          ) : null}
        </div>
      ))}

      <button className="btn btn-primary" onClick={handleApply}>Apply</button>
    </ModalWrapper>
  );
};

export default ConfirmationDialog;
